export default {
  // 供应商管理
  postProviderCreate: "/cms/provider/create", // 新增
  postProviderEdit: "/cms/provider/edit", // 编辑
  providerPage: "/cms/provider/page", // 分页查询
  providerServiceList: "/cms/provider/service/list", // 供应商及服务列表
  postProviderStatus: "/cms/provider/status", // 启用停用
  postProviderStatusCheck: "/cms/service/check/item", // 停用校验
  postProviderView: "/cms/provider/view", // 查看
  downLoadProviderImport: "/cms/provider/downTemplate", // 下载导入模版
  postProviderImport: "/cms/provider/uploadTemplate", // Excel批量导入供应商
  postProviderExport: "/cms/provider/export", // 批量导出供应商
  postProviderRateExport: "/cms/provider/rate/export", // 批量导出供应商评价
  postProviderRateEdit: "/cms/provider/rate/rate", // 编辑供应商评价



  // 门店 | 网点管理
  postHospitalCreate: "/cms/hospital/create", // 新增
  postHospitalDelete: "/cms/hospital/delete", // 删除
  postHospitalImport: "/cms/hospital/import", // Excel导入
  hospitalPage: "/cms/hospital/page", // 分页查询
  hospitalTree: "/cms/hospital/tree", // 供应商门店数
  postHospitalView: "/cms/hospital/view", // 查看
  postHospitalEdit: "/cms/hospital/edit", // 编辑
  postHospitalStatus: "/cms/hospital/status", // 启用停用
  hospitalExport: "/cms/hospital/export", // 网点导出
  supplierArea: "/cms/provider/area/list", // 供应商地址列表


  // 服务管理
  postServiceCreate: "/cms/service/create", // 新增
  postServiceEdit: "/cms/service/edit", // 编辑 ？
  postServiceHospitalRel: "/cms/service/hospital/rel", // 批量设置服务网点
  postServiceImport: "/cms/service/import", // Excel导入
  postServiceExport: "/cms/service/export", // 批量设置服务网点

  serviceList: "/cms/service/list", // 供应商服务列表
  servicePage: "/cms/service/page", // 分页查询
  postServiceStatus: "/cms/service/status", // 启用停用
  serviceView: "/cms/service/view", // 查看
  serviceHospitalList: "/cms/hospital/service/list", // 查看
  serviceEdit: "/cms/service/edit", // 编辑
  serviceDelete: "/cms/service/delete", // 删除

  // 体检报告审核
  checkPage: "/cms/exam/report/check/page", // 分页查询体检报告审核列表
};